import { render } from "./PanelRelatedItem.vue?vue&type=template&id=549c0ce0&scoped=true&ts=true"
import script from "./PanelRelatedItem.vue?vue&type=script&lang=ts"
export * from "./PanelRelatedItem.vue?vue&type=script&lang=ts"

import "./PanelRelatedItem.vue?vue&type=style&index=0&id=549c0ce0&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-549c0ce0"]])

export default __exports__